import { useContacts } from '@entities/contacts';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUpdateMe } from '@pages/personal/model.ts';
import { EditorPersonalCoach } from '@widgets/personal/editor-personal-coach';
import { useCoacheEditorSavedData } from '@widgets/personal/editor-personal-coach/model/model.ts';
import { useDescriptionEditor } from '@widgets/shared/descriptionEditor/model.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { usePartitionsWithTagsSelection } from '@shared/hooks/use-partitions-with-tags-selection.ts';
import { useCloseFormDialogModal } from '@shared/hooks/useCloseFormDialogModal/useCloseFormDialogModal.ts';
import { PageHead, PageTitle, TextButton } from '@shared/ui';
import { Container } from '@src/library/components/ui';
import * as st from './styles.module.scss';

const hash = 'CoacheEditorForm';

export const EditorCoach: React.FC = () => {
  const { setSelectedContacts } = useContacts();
  const { doRemoveStorageData } = useCoacheEditorSavedData();
  const { clearStorage: clearDescription } = useDescriptionEditor(hash);
  const { clearPartitionsData } = usePartitionsWithTagsSelection({ hash });
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const { isLoading } = useUpdateMe();
  const { doCloseFormWithDialogModal } = useCloseFormDialogModal();
  const [isShouldCloseModalOpen, setIsShouldCloseModalOpen] = useState(false);

  const handleClickBack = doCloseFormWithDialogModal({
    isShouldModalOpen: isShouldCloseModalOpen,
    text: 'Внесенные изменения не сохранятся',
    title: 'Закрыть страницу?',
    onModalConfirm: () => {
      setSelectedContacts([]);
      doRemoveStorageData();
      clearDescription();
      clearPartitionsData();
      navigate('/personal');
    },
  });

  const handleClickSubmit = () => {
    if (formRef) {
      formRef.current?.requestSubmit();
    }
  };

  return (
    <Container style={{ position: 'relative' }}>
      <PageTitle title={`Редактирование профиля`} />
      <PageHead
        Left={<PageBackButton onClick={handleClickBack}></PageBackButton>}
        Right={
          <TextButton type="submit" onClick={handleClickSubmit} disabled={isLoading}>
            Готово
          </TextButton>
        }
      />

      <section className={st.form__wrapper}>
        <EditorPersonalCoach
          ref={formRef}
          hash={hash}
          setIsShouldCloseModalOpen={setIsShouldCloseModalOpen}
        />
      </section>
    </Container>
  );
};
